import React, { useEffect, useState } from "react";
import { User } from "../../../models/Master/User";
import useStyles from "../MasterData.css";
import translation from "../../../i18n/i18.json";
import AllActions from "../../../actions";
import { useDispatch } from "react-redux";
import { FormError } from "../../../models/FormValidation/FormError";
import { FormFieldMeta } from "../../../models/FormValidation/FormFieldMeta";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";

import {
  Chip,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  MenuItem,
  Select,
  ListItemText,
} from "@material-ui/core";
import {
  InforDisplyaDuration,
  App_Roles,
  NonRMCategoryManagedBys,
  ServicesCategoryManagedBys,
  VendorCategoryData
} from "../../../constants/AppConstants";
import { FormUtil } from "../../../utils/FormUtil";
import { FormValidateData } from "../../../models/FormValidation/FormValidateData";
import { UserCompany } from "../../../models/UserCompany";
import { UserCluster } from "../../../models/UserCluster";
import { UserRMCategory } from "../../../models/UserRMCategory";
import { UserProcurementCategory } from "../../../models/UserProcurementCategory";
import { UserProcurementSubCategory } from "../../../models/UserProcurementSubCategory";
import { ProcurementSubCategory } from "../../../models/ProcurementSubCategory";
import { ProcurementCategory } from "../../../models/ProcurementCategory";

interface CategoryAddDialogProps {
  open: boolean;
  handleClose: any;
  dataObj: User;
  setDataObj: any;
  successUpdate: any;
  userRmCategoryList: UserRMCategory[];
  userProcurementCategoryList: UserProcurementCategory[];
  userProcurementSubCategoryList: UserProcurementSubCategory[];
}

export default function CategoryAddDialog(props: CategoryAddDialogProps) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    open,
    handleClose,
    dataObj,
    setDataObj,
    successUpdate,
    userRmCategoryList,
    userProcurementCategoryList,
    userProcurementSubCategoryList
  } = props;
  const initialState: User = {
    id: 0,
    userName: "",
    userCompanies: [],
    userClusters: [],
    isActive: true,
    emailAddress: ""
  };
  const initialUserCompany: UserCompany = {
    id: 0,
    companyCode: "",
    roleIds: [],
    approvalPointIds: [],
    rmCategoryIds: [],
    procurementCategoryIds: [],
    procurementSubCategoryIds: [],
  };
  const initialUserCluster: UserCluster = {
    id: 0,
    clusterId: 0,
    clusterName: "",
    roleIds: [],
    approvalPointIds: [],
    rmCategoryIds: [],
    procurementCategoryIds: [],
    procurementSubCategoryIds: []
  };
  const [formErrors, setFormErrors] = useState<FormError[]>([]);
  const [fistSubmitDone, setFistSubmitDone] = useState(false);
  const [procurementSubcategories, setProcurementSubCategories] = useState(Array<UserProcurementSubCategory>());
  const [procurementCategories, setProcurementCategories] = useState(Array<UserProcurementCategory>());
  const validateFieldsData: Array<FormFieldMeta> = [

  ];

  useEffect(() => {
    if (open) {
      if (dataObj.userClusters.length > 0) {
        let procurementCats: ProcurementCategory[] = [];
        if (dataObj.userClusters[0].roleIds.includes(App_Roles.NMRPCategoryManager) || dataObj.userClusters[0].roleIds.includes(App_Roles.NMRPPillarLead)) {
          userProcurementCategoryList.forEach(p => {
            if (p.vendorCategoryId == VendorCategoryData.NonRM) {
              procurementCats.push(p);
            }
          });
          setProcurementCategories(procurementCats);
        }
        if (dataObj.userClusters[0].roleIds.includes(App_Roles.ServicePillarLead)) {
          userProcurementCategoryList.forEach(p => {
            if (p.vendorCategoryId == VendorCategoryData.Services) {
              procurementCats.push(p);
            }
          });
          setProcurementCategories(procurementCats);
        }
        if (dataObj.userClusters[0].procurementCategoryIds.length > 0) {
          let procurementSubcats: ProcurementSubCategory[] = [];
          if (dataObj.userClusters[0].roleIds.includes(App_Roles.NMRPCategoryManager)) {
            userProcurementSubCategoryList.forEach(p => {
              if (dataObj.userClusters[0].procurementCategoryIds.find(e => e == p.procurementCategoryId) && (p.refSpendManagedById == NonRMCategoryManagedBys.Legato || p.refSpendManagedById == NonRMCategoryManagedBys.GroupProcurement_Legato)) {
                //procurementSubcats.push(p);
                if (!procurementSubcats.includes(p)) {
                  procurementSubcats.push(p);
                }
              }
            });
            setProcurementSubCategories(procurementSubcats);
          }
          if (dataObj.userClusters[0].roleIds.includes(App_Roles.NMRPPillarLead)) {
            userProcurementSubCategoryList.forEach(p => {
              if (dataObj.userClusters[0].procurementCategoryIds.find(e => e == p.procurementCategoryId) && (p.refSpendManagedById == NonRMCategoryManagedBys.GroupProcurement || p.refSpendManagedById == NonRMCategoryManagedBys.GroupProcurement_Legato)) {
                //procurementSubcats.push(p);
                if (!procurementSubcats.includes(p)) {
                  procurementSubcats.push(p);
                }

              }
            });
            setProcurementSubCategories(procurementSubcats);
          }
          if (dataObj.userClusters[0].roleIds.includes(App_Roles.ServicePillarLead)) {
            userProcurementSubCategoryList.forEach(p => {
              if (dataObj.userClusters[0].procurementCategoryIds.find(e => e == p.procurementCategoryId) && (p.refSpendManagedById == ServicesCategoryManagedBys.GroupProcurement || p.refSpendManagedById == ServicesCategoryManagedBys.GroupProcurement_SBU)) {
                //procurementSubcats.push(p);
                if (!procurementSubcats.includes(p)) {
                  procurementSubcats.push(p);
                }
              }
            });
            setProcurementSubCategories(procurementSubcats);
          }
          /*  userProcurementSubCategoryList.forEach(p => {
             if (dataObj.userClusters[0].procurementCategoryIds.find(e => e == p.procurementCategoryId)) {
               procurementSubcats.push(p);
 
             }
           });
           setProcurementSubCategories(procurementSubcats); */
        }
        else {
          setProcurementSubCategories([]);
        }
      }
      else if (dataObj.userCompanies.length > 0) {
        let procurementCats: ProcurementCategory[] = [];
        if (dataObj.userCompanies[0].roleIds.includes(App_Roles.NMRPCategoryManager) || dataObj.userCompanies[0].roleIds.includes(App_Roles.NMRPPillarLead)) {
          userProcurementCategoryList.forEach(p => {
            if (p.vendorCategoryId == VendorCategoryData.NonRM) {
              procurementCats.push(p);
            }
          });
          setProcurementCategories(procurementCats);
        }
        if (dataObj.userCompanies[0].roleIds.includes(App_Roles.ServicePillarLead)) {
          userProcurementCategoryList.forEach(p => {
            if (p.vendorCategoryId == VendorCategoryData.Services) {
              procurementCats.push(p);
            }
          });
          setProcurementCategories(procurementCats);
        }
        if (dataObj.userCompanies[0].procurementCategoryIds.length > 0) {
          let procurementSubcats: ProcurementSubCategory[] = [];
          if (dataObj.userCompanies[0].roleIds.includes(App_Roles.NMRPCategoryManager)) {
            userProcurementSubCategoryList.forEach(p => {
              if (dataObj.userCompanies[0].procurementCategoryIds.find(e => e == p.procurementCategoryId) && (p.refSpendManagedById == NonRMCategoryManagedBys.Legato || p.refSpendManagedById == NonRMCategoryManagedBys.GroupProcurement_Legato)) {
                //procurementSubcats.push(p);
                if (!procurementSubcats.includes(p)) {
                  procurementSubcats.push(p);
                }
              }
            });
            setProcurementSubCategories(procurementSubcats);
          }
          if (dataObj.userCompanies[0].roleIds.includes(App_Roles.NMRPPillarLead)) {
            userProcurementSubCategoryList.forEach(p => {
              if (dataObj.userCompanies[0].procurementCategoryIds.find(e => e == p.procurementCategoryId) && (p.refSpendManagedById == NonRMCategoryManagedBys.GroupProcurement || p.refSpendManagedById == NonRMCategoryManagedBys.GroupProcurement_Legato)) {
                //procurementSubcats.push(p);
                if (!procurementSubcats.includes(p)) {
                  procurementSubcats.push(p);
                }
              }
            });
            setProcurementSubCategories(procurementSubcats);
          }
          if (dataObj.userCompanies[0].roleIds.includes(App_Roles.ServicePillarLead)) {
            userProcurementSubCategoryList.forEach(p => {
              if (dataObj.userCompanies[0].procurementCategoryIds.find(e => e == p.procurementCategoryId) && (p.refSpendManagedById == ServicesCategoryManagedBys.GroupProcurement || p.refSpendManagedById == ServicesCategoryManagedBys.GroupProcurement_SBU)) {
                //procurementSubcats.push(p);              
                if (!procurementSubcats.includes(p)) {
                  procurementSubcats.push(p);
                }
              }
            });
            setProcurementSubCategories(procurementSubcats);
          }
          /* userProcurementSubCategoryList.forEach(p => {
            if (dataObj.userCompanies[0].procurementCategoryIds.find(e => e == p.procurementCategoryId)) {
              procurementSubcats.push(p);
            }
          });
          setProcurementSubCategories(procurementSubcats); */
        }
        else {
          setProcurementSubCategories([]);
        }
      }
    }
  }, [open, dataObj.userCompanies[0], dataObj.userClusters[0], userProcurementSubCategoryList, userProcurementCategoryList]);

  useEffect(() => {
    if (fistSubmitDone) {
      validateData();
    }
  }, [dataObj]);

  const handleExit = (e: any) => {
    setDataObj(initialState);
    setFormErrors([]);
    setFistSubmitDone(false);
  };

  const validateData = () => {
    var isValid = true;

    //check rmcategories 
    if ((dataObj.userCompanies && dataObj.userCompanies.find(c => { return c.roleIds.includes(App_Roles.GSSCCategoryLead) && (!c.rmCategoryIds || c.rmCategoryIds.length == 0); }))
      || (dataObj.userClusters && dataObj.userClusters.find(c => { return c.roleIds.includes(App_Roles.GSSCCategoryLead) && (!c.rmCategoryIds || c.rmCategoryIds.length == 0); }))) {
      isValid = false;
      dispatch(AllActions.infoActions.openInforError(
        "Please add one or more RM Categories to the selected role.", InforDisplyaDuration.common));
    }
    if ((dataObj.userCompanies && dataObj.userCompanies.find(c => { return c.roleIds.includes(App_Roles.NMRPCategoryManager) && (!c.procurementCategoryIds || c.procurementCategoryIds.length == 0); }))
      || (dataObj.userClusters && dataObj.userClusters.find(c => { return c.roleIds.includes(App_Roles.NMRPCategoryManager) && (!c.procurementCategoryIds || c.procurementCategoryIds.length == 0); }))) {
      isValid = false;
      dispatch(AllActions.infoActions.openInforError(
        "Please add one or more Procurement Categories to the selected role.", InforDisplyaDuration.common));
    }
    if ((dataObj.userCompanies && dataObj.userCompanies.find(c => { return c.roleIds.includes(App_Roles.NMRPPillarLead) && (!c.procurementCategoryIds || c.procurementCategoryIds.length == 0); }))
      || (dataObj.userClusters && dataObj.userClusters.find(c => { return c.roleIds.includes(App_Roles.NMRPPillarLead) && (!c.procurementCategoryIds || c.procurementCategoryIds.length == 0); }))) {
      isValid = false;
      dispatch(AllActions.infoActions.openInforError(
        "Please add one or more Procurement Categories to the selected role.", InforDisplyaDuration.common));
    }
    if ((dataObj.userCompanies && dataObj.userCompanies.find(c => { return c.roleIds.includes(App_Roles.ServicePillarLead) && (!c.procurementCategoryIds || c.procurementCategoryIds.length == 0); }))
      || (dataObj.userClusters && dataObj.userClusters.find(c => { return c.roleIds.includes(App_Roles.ServicePillarLead) && (!c.procurementCategoryIds || c.procurementCategoryIds.length == 0); }))) {
      isValid = false;
      dispatch(AllActions.infoActions.openInforError(
        "Please add one or more Procurement Categories to the selected role.", InforDisplyaDuration.common));
    }
    if ((dataObj.userCompanies && dataObj.userCompanies.find(c => { return c.roleIds.includes(App_Roles.NMRPCategoryManager) && (!c.procurementSubCategoryIds || c.procurementSubCategoryIds.length == 0); }))
      || (dataObj.userClusters && dataObj.userClusters.find(c => { return c.roleIds.includes(App_Roles.NMRPCategoryManager) && (!c.procurementSubCategoryIds || c.procurementSubCategoryIds.length == 0); }))) {
      isValid = false;
      dispatch(AllActions.infoActions.openInforError(
        "Please add one or more Procurement Sub Categories to the selected role.", InforDisplyaDuration.common));
    }
    if ((dataObj.userCompanies && dataObj.userCompanies.find(c => { return c.roleIds.includes(App_Roles.NMRPPillarLead) && (!c.procurementSubCategoryIds || c.procurementSubCategoryIds.length == 0); }))
      || (dataObj.userClusters && dataObj.userClusters.find(c => { return c.roleIds.includes(App_Roles.NMRPPillarLead) && (!c.procurementSubCategoryIds || c.procurementSubCategoryIds.length == 0); }))) {
      isValid = false;
      dispatch(AllActions.infoActions.openInforError(
        "Please add one or more Procurement Sub Categories to the selected role.", InforDisplyaDuration.common));
    }
    if ((dataObj.userCompanies && dataObj.userCompanies.find(c => { return c.roleIds.includes(App_Roles.ServicePillarLead) && (!c.procurementSubCategoryIds || c.procurementSubCategoryIds.length == 0); }))
      || (dataObj.userClusters && dataObj.userClusters.find(c => { return c.roleIds.includes(App_Roles.ServicePillarLead) && (!c.procurementSubCategoryIds || c.procurementSubCategoryIds.length == 0); }))) {
      isValid = false;
      dispatch(AllActions.infoActions.openInforError(
        "Please add one or more Procurement Sub Categories to the selected role.", InforDisplyaDuration.common));
    }
    if (!isProcurementSubCatComplete()) {
      isValid = false;
      dispatch(AllActions.infoActions.openInforError(
        "Procurement Sub Categories are incomplete.", InforDisplyaDuration.common));
    }
    let formValidateData: FormValidateData = FormUtil.validateFields(
      validateFieldsData,
      dataObj
    );

    setFormErrors(formValidateData.errorsList);
    return formValidateData.isValid && isValid;
  };

  const isProcurementSubCatComplete = () => {
    for (let i = 0; i < dataObj.userCompanies.length; i++) {
      let sub = userProcurementSubCategoryList.filter(z => (dataObj.userCompanies[i].procurementSubCategoryIds).includes(z.id)).map(c => c.procurementCategoryId);
      let pro = dataObj.userCompanies[i].procurementCategoryIds;
      let variance = pro.filter(x => !sub.includes(x));
      if (variance.length > 0) {
        return false;
        break;
      }
      if (dataObj.userCompanies[i].roleIds.includes(App_Roles.ServicePillarLead)) {
        let serviceProcurementCat = userProcurementCategoryList.filter((r) => {
          return r.vendorCategoryId == VendorCategoryData.Services;
        });
        if (dataObj.userCompanies[i].procurementCategoryIds.some(v => serviceProcurementCat.map(item => item.id).includes(v))) {
        }
        else {
          return false;
          break;
        }
      }
      if (dataObj.userCompanies[i].roleIds.includes(App_Roles.NMRPPillarLead)) {
        let nonRMProcurementCat = userProcurementCategoryList.filter((r) => {
          return r.vendorCategoryId == VendorCategoryData.NonRM;
        });
        if (dataObj.userCompanies[i].procurementCategoryIds.some(v => nonRMProcurementCat.map(item => item.id).includes(v))) {
        }
        else {
          return false;
          break;
        }
      }
    }
    for (let i = 0; i < dataObj.userClusters.length; i++) {
      let sub = userProcurementSubCategoryList.filter(z => (dataObj.userClusters[i].procurementSubCategoryIds).includes(z.id)).map(c => c.procurementCategoryId);
      let pro = dataObj.userClusters[i].procurementCategoryIds;
      let variance = pro.filter(x => !sub.includes(x));
      if (variance.length > 0) {
        return false;
        break;
      }
      if (dataObj.userClusters[i].roleIds.includes(App_Roles.ServicePillarLead)) {
        let serviceProcurementCat = userProcurementCategoryList.filter((r) => {
          return r.vendorCategoryId == VendorCategoryData.Services;
        });
        if (dataObj.userClusters[i].procurementCategoryIds.some(v => serviceProcurementCat.map(item => item.id).includes(v))) {
        }
        else {
          return false;
          break;
        }
      }
      if (dataObj.userClusters[i].roleIds.includes(App_Roles.NMRPPillarLead)) {
        let nonRMProcurementCat = userProcurementCategoryList.filter((r) => {
          return r.vendorCategoryId == VendorCategoryData.NonRM;
        });
        if (dataObj.userClusters[i].procurementCategoryIds.some(v => nonRMProcurementCat.map(item => item.id).includes(v))) {
        }
        else {
          return false;
          break;
        }
      }
    }
    return true;
  };

  const handleSaveExit = (e: any) => {
    setFistSubmitDone(true);
    if (validateData()) {
      console.log(dataObj);
      successUpdate(dataObj);
      handleClose();

    }
  };

  const setClusterRMCategories = (clusterId: number, rmCategoryIds: number[]) => {
    let userCluster = dataObj.userClusters.find((c) => {
      return c.clusterId == clusterId;
    }) as UserCluster;
    userCluster.rmCategoryIds = rmCategoryIds;
    setDataObj({
      ...dataObj,
      ["userClusters"]: [...dataObj.userClusters]//create new array of user companies
    });
  };

  const setClusterProcurementCategories = (clusterId: number, procurementCategoryIds: number[]) => {
    let userCluster = dataObj.userClusters.find((c) => {
      return c.clusterId == clusterId;
    }) as UserCluster;
    userCluster.procurementCategoryIds = procurementCategoryIds;
    setDataObj({
      ...dataObj,
      ["userClusters"]: [...dataObj.userClusters]//create new array of user companies
    });
  };

  const setClusterProcurementSubCategories = (clusterId: number, procurementSubCategoryIds: number[]) => {
    let userCluster = dataObj.userClusters.find((c) => {
      return c.clusterId == clusterId;
    }) as UserCluster;
    userCluster.procurementSubCategoryIds = procurementSubCategoryIds;
    setDataObj({
      ...dataObj,
      ["userClusters"]: [...dataObj.userClusters]//create new array of user companies
    });
  };

  const setCompanyRMCategories = (companyCode: string, rmCategoryIds: number[]) => {
    let userCompany = dataObj.userCompanies.find((c) => {
      return c.companyCode == companyCode;
    }) as UserCompany;
    userCompany.rmCategoryIds = rmCategoryIds;
    setDataObj({
      ...dataObj,
      ["userCompanies"]: [...dataObj.userCompanies]//create new array of user companies
    });
  };

  const setCompanyProcurementCategories = (companyCode: string, procurementCategoryIds: number[]) => {
    let userCompany = dataObj.userCompanies.find((c) => {
      return c.companyCode == companyCode;
    }) as UserCompany;
    userCompany.procurementCategoryIds = procurementCategoryIds;
    setDataObj({
      ...dataObj,
      ["userCompanies"]: [...dataObj.userCompanies]//create new array of user companies
    });
  };

  const setCompanyProcurementSubCategories = (companyCode: string, procurementSubCategoryIds: number[]) => {
    let userCompany = dataObj.userCompanies.find((c) => {
      return c.companyCode == companyCode;
    }) as UserCompany;
    userCompany.procurementSubCategoryIds = procurementSubCategoryIds;
    setDataObj({
      ...dataObj,
      ["userCompanies"]: [...dataObj.userCompanies]//create new array of user companies
    });
  };

  const setUserRmCategories = (companyCode: string, clusterId: number, rmCategoryIds: number[]) => {
    if (clusterId) {
      setClusterRMCategories(clusterId, rmCategoryIds);
    } else if (companyCode) {
      setCompanyRMCategories(companyCode, rmCategoryIds);
    }
  };

  const setUserProcurementCategories = (companyCode: string, clusterId: number, procurementCategoryIds: number[]) => {
    if (clusterId) {
      setClusterProcurementCategories(clusterId, procurementCategoryIds);
    } else if (companyCode) {
      setCompanyProcurementCategories(companyCode, procurementCategoryIds);
    }
  };

  const setUserProcurementSubCategories = (companyCode: string, clusterId: number, procurementSubCategoryIds: number[]) => {
    if (clusterId) {
      setClusterProcurementSubCategories(clusterId, procurementSubCategoryIds);
    } else if (companyCode) {
      setCompanyProcurementSubCategories(companyCode, procurementSubCategoryIds);
    }
  };

  const handleChange = (input: string, companyCode: string, clusterId: number) => (e: any) => {
    if (e.target.type === "checkbox") {
      setDataObj({
        ...dataObj,
        [input]: e.target.checked,
      });
    }
    else if (input === "rmCategoryIds") {
      setUserRmCategories(companyCode, clusterId, e.target.value);
    }
    else if (input === "procurementCategoryIds") {
      setUserProcurementCategories(companyCode, clusterId, e.target.value);
    }
    else if (input === "procurementSubCategoryIds") {
      setUserProcurementSubCategories(companyCode, clusterId, e.target.value);
    }
    else {
      setDataObj({
        ...dataObj,
        [input]: e.target.value,
      });
    }

  };

  const getErrorState = (input: string) => {
    return FormUtil.getErrorState(input, formErrors);
  };

  const getRMCategoryName = (rmCategoryId: number) => {
    return userRmCategoryList.find(v => v.id == rmCategoryId)?.rmCategoryName;
  };

  const getProcurementCategoryName = (procurementCategoryId: number) => {
    return userProcurementCategoryList.find(v => v.id == procurementCategoryId)?.procurementCategoryName;
  };

  const getProcurementSubCategoryName = (procurementSubCategoryId: number) => {
    return userProcurementSubCategoryList.find(v => v.id == procurementSubCategoryId)?.name;
  };

  const handleDelete = (
    e: React.MouseEvent,
    value: string | number,
    input: string,
    companyCode: string,
    clusterId: number
  ) => {
    e.preventDefault();

    if (input === "rmCategoryIds") {
      if (clusterId) {
        let userCluster = dataObj.userClusters.find((c) => {
          return c.clusterId == clusterId;
        }) as UserCluster;
        userCluster.rmCategoryIds = userCluster.rmCategoryIds.filter((r) => {
          return r != value;
        });
        setDataObj({
          ...dataObj,
          ["userClusters"]: [...dataObj.userClusters]
        });
      } else if (companyCode) {
        let userCompany = dataObj.userCompanies.find((c) => {
          return c.companyCode == companyCode;
        }) as UserCompany;
        userCompany.rmCategoryIds = userCompany.rmCategoryIds.filter((r) => {
          return r != value;
        });
        setDataObj({
          ...dataObj,
          ["userCompanies"]: [...dataObj.userCompanies]
        });
      }
    }
    else if (input === "procurementCategoryIds") {
      if (clusterId) {
        let userCluster = dataObj.userClusters.find((c) => {
          return c.clusterId == clusterId;
        }) as UserCluster;
        userCluster.procurementCategoryIds = userCluster.procurementCategoryIds.filter((r) => {
          return r != value;
        });
        userCluster.procurementSubCategoryIds = [];
        setDataObj({
          ...dataObj,
          ["userClusters"]: [...dataObj.userClusters]
        });
      } else if (companyCode) {
        let userCompany = dataObj.userCompanies.find((c) => {
          return c.companyCode == companyCode;
        }) as UserCompany;
        userCompany.procurementCategoryIds = userCompany.procurementCategoryIds.filter((r) => {
          return r != value;
        });
        userCompany.procurementSubCategoryIds = [];
        setDataObj({
          ...dataObj,
          ["userCompanies"]: [...dataObj.userCompanies]
        });
      }
    }
    else if (input === "procurementSubCategoryIds") {
      if (clusterId) {
        let userCluster = dataObj.userClusters.find((c) => {
          return c.clusterId == clusterId;
        }) as UserCluster;
        userCluster.procurementSubCategoryIds = userCluster.procurementSubCategoryIds.filter((r) => {
          return r != value;
        });
        setDataObj({
          ...dataObj,
          ["userClusters"]: [...dataObj.userClusters]
        });
      } else if (companyCode) {
        let userCompany = dataObj.userCompanies.find((c) => {
          return c.companyCode == companyCode;
        }) as UserCompany;
        userCompany.procurementSubCategoryIds = userCompany.procurementSubCategoryIds.filter((r) => {
          return r != value;
        });
        setDataObj({
          ...dataObj,
          ["userCompanies"]: [...dataObj.userCompanies]
        });
      }
    }
  };

  const getCheckedProcurementCategory = (ur: UserProcurementCategory, companyCode: string, clusterId: number) => {
    if (clusterId) {
      let userCluster = dataObj.userClusters.find((c) => {
        return c.clusterId == clusterId;
      }) as UserCluster;
      if (userCluster) {
        let exists = userCluster.procurementCategoryIds.findIndex((r) => {
          return r === ur.id;
        });
        return exists !== -1;
      }
      return false;
    } else if (companyCode) {
      let userCompany = dataObj.userCompanies.find((c) => {
        return c.companyCode == companyCode;
      }) as UserCompany;
      if (userCompany) {
        let exists = userCompany.procurementCategoryIds.findIndex((r) => {
          return r === ur.id;
        });
        return exists !== -1;
      }
      return false;
    }
  };

  const getCheckedProcurementSubCategory = (ur: UserProcurementSubCategory, companyCode: string, clusterId: number) => {
    if (clusterId) {
      let userCluster = dataObj.userClusters.find((c) => {
        return c.clusterId == clusterId;
      }) as UserCluster;
      if (userCluster) {
        let exists = userCluster.procurementSubCategoryIds.findIndex((r) => {
          return r === ur.id;
        });
        return exists !== -1;
      }
      return false;
    } else if (companyCode) {
      let userCompany = dataObj.userCompanies.find((c) => {
        return c.companyCode == companyCode;
      }) as UserCompany;
      if (userCompany) {
        let exists = userCompany.procurementSubCategoryIds.findIndex((r) => {
          return r === ur.id;
        });
        return exists !== -1;
      }
      return false;
    }
  };


  const getCheckedRMCategory = (ur: UserRMCategory, companyCode: string, clusterId: number) => {
    if (clusterId) {
      let userCluster = dataObj.userClusters.find((c) => {
        return c.clusterId == clusterId;
      }) as UserCluster;
      if (userCluster) {
        let exists = userCluster.rmCategoryIds.findIndex((r) => {
          return r === ur.id;
        });
        return exists !== -1;
      }
      return false;
    } else if (companyCode) {
      let userCompany = dataObj.userCompanies.find((c) => {
        return c.companyCode == companyCode;
      }) as UserCompany;
      if (userCompany) {
        let exists = userCompany.rmCategoryIds.findIndex((r) => {
          return r === ur.id;
        });
        return exists !== -1;
      }
      return false;
    }
  };


  return (
    <div className={classes.popUpOuter}>
      <Dialog
        open={open}
        onClose={handleClose}
        onExit={handleExit}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="md"
      /* style={{maxWidth:1006} } */
      >
        <DialogTitle className={classes.popUpHeader} id="alert-dialog-title">
          {translation.master_rm_procurement_dialog_title}
        </DialogTitle>
        <DialogContent className={classes.NoPopWrapper} style={{ width: 600 }}>
          {
            <div>
              {(dataObj.userCompanies.length > 0) && (dataObj.userCompanies[0].roleIds.includes(App_Roles.GSSCCategoryLead)) ? (
                <Grid container spacing={2} item xs={12} sm={12} md={12} lg={12}>
                  <span className={classes.createLbl}>
                    {translation.master_user_dialog_rmcategory}
                  </span>
                  <div className={classes.inputWrapper_Req} style={{ width: 500 }}>
                    <Select
                      variant="outlined"
                      multiple
                      value={((dataObj.userCompanies[0] != undefined) ? dataObj.userCompanies[0].rmCategoryIds : []) || []}
                      onChange={handleChange("rmCategoryIds", (dataObj.userCompanies[0] != undefined) ? dataObj.userCompanies[0].companyCode : "", 0)}
                      error={getErrorState("rmCategoryIds")}
                      renderValue={(selected) => (
                        <div>
                          {(selected as number[]).map((rmCategoryId) => (
                            <Chip
                              key={rmCategoryId}
                              label={getRMCategoryName(rmCategoryId)}
                              clickable
                              deleteIcon={
                                <CancelIcon
                                  onMouseDown={(event) => event.stopPropagation()}
                                />
                              }
                              onDelete={(e) =>
                                handleDelete(e, rmCategoryId, "rmCategoryIds", (dataObj.userCompanies[0] != undefined) ? dataObj.userCompanies[0].companyCode : "", 0)
                              }
                              onClick={() => console.log("clicked chip")}
                            />
                          ))}
                        </div>
                      )}
                    >
                      {userRmCategoryList.map((obj, index) => (
                        <MenuItem key={obj.id} value={obj.id}>
                          <Checkbox checked={getCheckedRMCategory(obj, (dataObj.userCompanies[0] != undefined) ? dataObj.userCompanies[0].companyCode : "", 0)} />
                          <ListItemText primary={obj.rmCategoryName} />
                        </MenuItem>
                      ))}
                    </Select>
                  </div>
                </Grid>) : <div></div>}
              {(dataObj.userCompanies.length > 0) && (dataObj.userCompanies[0].roleIds.includes(App_Roles.NMRPCategoryManager) || dataObj.userCompanies[0].roleIds.includes(App_Roles.NMRPPillarLead) || dataObj.userCompanies[0].roleIds.includes(App_Roles.ServicePillarLead)) ? (
                <Grid container spacing={2} item xs={12} sm={12} md={12} lg={12}>
                  <span className={classes.createLbl}>
                    {translation.master_user_dialog_procurementcategory}
                  </span>
                  <div className={classes.inputWrapper_Req} style={{ width: 500 }}>
                    <Select
                      variant="outlined"
                      multiple
                      value={((dataObj.userCompanies[0] != undefined) ? dataObj.userCompanies[0].procurementCategoryIds : []) || []}
                      onChange={handleChange("procurementCategoryIds", (dataObj.userCompanies[0] != undefined) ? dataObj.userCompanies[0].companyCode : "", 0)}
                      error={getErrorState("procurementCategoryIds")}
                      renderValue={(selected) => (
                        <div>
                          {(selected as number[]).map((procurementCategoryId) => (
                            <Chip
                              key={procurementCategoryId}
                              label={getProcurementCategoryName(procurementCategoryId)}
                              clickable
                              deleteIcon={
                                <CancelIcon
                                  onMouseDown={(event) => event.stopPropagation()}
                                />
                              }
                              onDelete={(e) =>
                                handleDelete(e, procurementCategoryId, "procurementCategoryIds", (dataObj.userCompanies[0] != undefined) ? dataObj.userCompanies[0].companyCode : "", 0)
                              }
                              onClick={() => console.log("clicked chip")}
                            />
                          ))}
                        </div>
                      )}
                    >
                      {procurementCategories.map((obj, index) => (
                        <MenuItem key={obj.id} value={obj.id}>
                          <Checkbox checked={getCheckedProcurementCategory(obj, (dataObj.userCompanies[0] != undefined) ? dataObj.userCompanies[0].companyCode : "", 0)} />
                          <ListItemText primary={obj.procurementCategoryName} />
                        </MenuItem>
                      ))}
                    </Select>
                  </div>
                </Grid>) : <div></div>}

              {(dataObj.userCompanies.length > 0) && (dataObj.userCompanies[0].roleIds.includes(App_Roles.NMRPCategoryManager) || dataObj.userCompanies[0].roleIds.includes(App_Roles.NMRPPillarLead) || dataObj.userCompanies[0].roleIds.includes(App_Roles.ServicePillarLead)) ? (
                <Grid container spacing={2} item xs={12} sm={12} md={12} lg={12}>
                  <span className={classes.createLbl}>
                    {translation.master_user_dialog_procurementsubcategory}
                  </span>
                  <div className={classes.inputWrapper_Req} style={{ width: 500 }}>
                    <Select
                      variant="outlined"
                      multiple
                      value={((dataObj.userCompanies[0] != undefined) ? dataObj.userCompanies[0].procurementSubCategoryIds : []) || []}
                      onChange={handleChange("procurementSubCategoryIds", (dataObj.userCompanies[0] != undefined) ? dataObj.userCompanies[0].companyCode : "", 0)}
                      error={getErrorState("procurementSubCategoryIds")}
                      renderValue={(selected) => (
                        <div>
                          {(selected as number[]).map((procurementSubCategoryId) => (
                            <Chip
                              key={procurementSubCategoryId}
                              label={getProcurementSubCategoryName(procurementSubCategoryId)}
                              clickable
                              deleteIcon={
                                <CancelIcon
                                  onMouseDown={(event) => event.stopPropagation()}
                                />
                              }
                              onDelete={(e) =>
                                handleDelete(e, procurementSubCategoryId, "procurementSubCategoryIds", (dataObj.userCompanies[0] != undefined) ? dataObj.userCompanies[0].companyCode : "", 0)
                              }
                              onClick={() => console.log("clicked chip")}
                            />
                          ))}
                        </div>
                      )}
                    >
                      {procurementSubcategories.map((obj, index) => (
                        <MenuItem key={obj.id} value={obj.id}>
                          <Checkbox checked={getCheckedProcurementSubCategory(obj, (dataObj.userCompanies[0] != undefined) ? dataObj.userCompanies[0].companyCode : "", 0)} />
                          <ListItemText primary={obj.name} />
                        </MenuItem>
                      ))}
                    </Select>
                  </div>
                </Grid>) : <div></div>}

              {(dataObj.userClusters.length > 0) && (dataObj.userClusters[0].roleIds.includes(App_Roles.GSSCCategoryLead)) ? (
                <Grid container spacing={2} item xs={12} sm={12} md={12} lg={12}>
                  <span className={classes.createLbl}>
                    {translation.master_user_dialog_rmcategory}
                  </span>
                  <div className={classes.inputWrapper_Req} style={{ width: 500 }}>
                    <Select
                      variant="outlined"
                      multiple
                      value={((dataObj.userClusters[0] != undefined) ? dataObj.userClusters[0].rmCategoryIds : []) || []}
                      onChange={handleChange("rmCategoryIds", "", (dataObj.userClusters[0] != undefined) ? dataObj.userClusters[0].clusterId : 0)}
                      error={getErrorState("rmCategoryIds")}
                      renderValue={(selected) => (
                        <div>
                          {(selected as number[]).map((rmCategoryId) => (
                            <Chip
                              key={rmCategoryId}
                              label={getRMCategoryName(rmCategoryId)}
                              clickable
                              deleteIcon={
                                <CancelIcon
                                  onMouseDown={(event) => event.stopPropagation()}
                                />
                              }
                              onDelete={(e) =>
                                handleDelete(e, rmCategoryId, "rmCategoryIds", "", (dataObj.userClusters[0] != undefined) ? dataObj.userClusters[0].clusterId : 0)
                              }
                              onClick={() => console.log("clicked chip")}
                            />
                          ))}
                        </div>
                      )}
                    >
                      {userRmCategoryList.map((obj, index) => (
                        <MenuItem key={obj.id} value={obj.id}>
                          <Checkbox checked={getCheckedRMCategory(obj, "", (dataObj.userClusters[0] != undefined) ? dataObj.userClusters[0].clusterId : 0)} />
                          <ListItemText primary={obj.rmCategoryName} />
                        </MenuItem>
                      ))}
                    </Select>
                  </div>
                </Grid>) : <div></div>}

              {(dataObj.userClusters.length > 0) && (dataObj.userClusters[0].roleIds.includes(App_Roles.NMRPCategoryManager) || dataObj.userClusters[0].roleIds.includes(App_Roles.NMRPPillarLead) || dataObj.userClusters[0].roleIds.includes(App_Roles.ServicePillarLead)) ? (
                <Grid container spacing={2} item xs={12} sm={12} md={12} lg={12}>
                  <span className={classes.createLbl}>
                    {translation.master_user_dialog_procurementcategory}
                  </span>
                  <div className={classes.inputWrapper_Req} style={{ width: 500 }}>
                    <Select
                      variant="outlined"
                      multiple
                      value={((dataObj.userClusters[0] != undefined) ? dataObj.userClusters[0].procurementCategoryIds : []) || []}
                      onChange={handleChange("procurementCategoryIds", "", (dataObj.userClusters[0] != undefined) ? dataObj.userClusters[0].clusterId : 0)}
                      error={getErrorState("procurementCategoryIds")}
                      renderValue={(selected) => (
                        <div>
                          {(selected as number[]).map((procurementCategoryId) => (
                            <Chip
                              key={procurementCategoryId}
                              label={getProcurementCategoryName(procurementCategoryId)}
                              clickable
                              deleteIcon={
                                <CancelIcon
                                  onMouseDown={(event) => event.stopPropagation()}
                                />
                              }
                              onDelete={(e) =>
                                handleDelete(e, procurementCategoryId, "procurementCategoryIds", "", (dataObj.userClusters[0] != undefined) ? dataObj.userClusters[0].clusterId : 0)
                              }
                              onClick={() => console.log("clicked chip")}
                            />
                          ))}
                        </div>
                      )}
                    >
                      {procurementCategories.map((obj, index) => (
                        <MenuItem key={obj.id} value={obj.id}>
                          <Checkbox checked={getCheckedProcurementCategory(obj, "", (dataObj.userClusters[0] != undefined) ? dataObj.userClusters[0].clusterId : 0)} />
                          <ListItemText primary={obj.procurementCategoryName} />
                        </MenuItem>
                      ))}
                    </Select>
                  </div>
                </Grid>) : <div></div>}

              {(dataObj.userClusters.length > 0) && (dataObj.userClusters[0].roleIds.includes(App_Roles.NMRPCategoryManager) || dataObj.userClusters[0].roleIds.includes(App_Roles.NMRPPillarLead) || dataObj.userClusters[0].roleIds.includes(App_Roles.ServicePillarLead)) ? (
                <Grid container spacing={2} item xs={12} sm={12} md={12} lg={12}>
                  <span className={classes.createLbl}>
                    {translation.master_user_dialog_procurementsubcategory}
                  </span>
                  <div className={classes.inputWrapper_Req} style={{ width: 500 }}>
                    <Select
                      variant="outlined"
                      multiple
                      value={((dataObj.userClusters[0] != undefined) ? dataObj.userClusters[0].procurementSubCategoryIds : []) || []}
                      onChange={handleChange("procurementSubCategoryIds", "", (dataObj.userClusters[0] != undefined) ? dataObj.userClusters[0].clusterId : 0)}
                      error={getErrorState("procurementSubCategoryIds")}
                      renderValue={(selected) => (
                        <div>
                          {(selected as number[]).map((procurementSubCategoryId) => (
                            <Chip
                              key={procurementSubCategoryId}
                              label={getProcurementSubCategoryName(procurementSubCategoryId)}
                              clickable
                              deleteIcon={
                                <CancelIcon
                                  onMouseDown={(event) => event.stopPropagation()}
                                />
                              }
                              onDelete={(e) =>
                                handleDelete(e, procurementSubCategoryId, "procurementSubCategoryIds", "", (dataObj.userClusters[0] != undefined) ? dataObj.userClusters[0].clusterId : 0)
                              }
                              onClick={() => console.log("clicked chip")}
                            />
                          ))}
                        </div>
                      )}
                    >
                      {procurementSubcategories.map((obj, index) => (
                        <MenuItem key={obj.id} value={obj.id}>
                          <Checkbox checked={getCheckedProcurementSubCategory(obj, "", (dataObj.userClusters[0] != undefined) ? dataObj.userClusters[0].clusterId : 0)} />
                          <ListItemText primary={obj.name} />
                        </MenuItem>
                      ))}
                    </Select>
                  </div>
                </Grid>) : <div></div>}
            </div>
          }
        </DialogContent>
        <DialogActions>
          <Grid style={{
            width: "50%",
            float: "left",
            margin: "5px 0px 25px 0px",
          }}
          >
          </Grid>
          <div style={{ margin: "20px ​10px 15px 0" }}>
            <div className={classes.greenBtnWrapper}>
              <Button onClick={handleSaveExit} color="primary">
                <CheckCircleIcon></CheckCircleIcon>
                {translation.vendor_detail_savebtn_lbl}
              </Button>
            </div>
            <div className={classes.grayBtnWrapper}>
              <Button onClick={handleClose} color="primary" autoFocus>
                {translation.master_add_dialog_cancelbtntxt}
              </Button>
            </div>
          </div>
        </DialogActions>
      </Dialog>
    </div>
  );
}
